import qs from 'qs';
import { createResource } from 'react-resource-router';

import { Pipeline } from 'src/components/pipelines/models/Pipeline';
import { ResourceContext } from 'src/router/types';

import envBaseUrl from '../utils/env-base-url';

import { fetchData } from './utils';

type Params = {
  workspaceSlug?: string;
};

const DEFAULT_LIST_SIZE = 5;

export type WorkspacePipelinesResponseBody = {
  page: number;
  pagelen: number;
  size: number;
  values: Pipeline[];
};

export const getWorkspacePipelinesUrl = (params: Params) => {
  const allQueryParams = {
    page: 1,
    pagelen: DEFAULT_LIST_SIZE,
    sort: '-created_on',
    fields:
      '+values.target.commit.message,' +
      '+values.target.selector.type,' +
      '+values.target.selector.pattern,' +
      '+values.target.commit.summary.html,' +
      '+values.target.*,+values.*,+page,+size',
  };
  return `${envBaseUrl('/!api/internal')}/workspaces/${
    params.workspaceSlug
  }/user/pipelines/?${qs.stringify(allQueryParams, {
    allowDots: true,
    arrayFormat: 'repeat',
  })}`;
};

const recentRepositoryFields =
  'values.uuid,' +
  'values.name,' +
  'values.workspace.name,' +
  'values.links.html.href,' +
  'values.links.avatar.href,' +
  'values.full_name,' +
  'values.landing_page,' +
  'values.fork_policy,' +
  'values.workspace.slug,' +
  'values.owner.uuid';
const MAX_NUMBER_OF_CARDS = 4;

export const getAdminRepositoriesUrl = (params: Params) => {
  const queryParams = qs.stringify({
    role: 'admin',
    pagelen: MAX_NUMBER_OF_CARDS,
    fields: recentRepositoryFields,
  });

  return `/!api/2.0/repositories/${params.workspaceSlug}?${queryParams}`;
};

export const loadWorkspacePipelinesResource = createResource({
  type: 'workspace-pipelines',
  getKey: ({ match }) => getWorkspacePipelinesUrl(match.params),
  maxAge: 60000,
  getData: async ({ match }, { appData }: ResourceContext) => {
    if (!appData.features.bitbucket_pipelines_table_on_workspace_overview)
      return { pipelines: [], repositories: [] };

    const data: WorkspacePipelinesResponseBody = await fetchData(
      getWorkspacePipelinesUrl(match.params),
      'workspace_pipelines_resource_exception'
    );
    const pipelines = data.values.map(item => new Pipeline(item));
    if (pipelines.length > 0) {
      return { pipelines, repositories: [] };
    }

    const repositoriesResponse = await fetchData(
      getAdminRepositoriesUrl(match.params),
      'admin_repositories_fetch_exception'
    );
    const repositories: BB.Repository[] = repositoriesResponse.values;
    return { pipelines: [], repositories };
  },
});
